module.exports = __webpack_public_path__ + "media/images/black_history_month/person-fb41613edfb6ef933cceee4afcacdee9.svg";